import React from 'react';

function AppHeaderDivider() {
  return (
    <div
      style={{
        borderLeft: '1px solid rgba(255, 255, 255, 0.3)',
        marginTop: '4px',
        marginBottom: '4px',
        marginRight: 4,
        marginLeft: 4,
      }}
    />
  );
}

export default AppHeaderDivider;
